import { createStyles, makeUiStyles, Theme } from '../../../styles/styles';
import { focusStyle } from '../../../styles/mixins';
import { StylesIndexInjections } from 'common-react';

export default makeUiStyles((theme: Theme) => createStyles({
  closeButtonWrapper: {
    padding: 0,
    display: 'flex',
    position: 'absolute',
    right: 24,
    top: 24,
    zIndex: 1,
    [theme.breakpoints.down('sm')]: {
      position: 'static',
      justifyContent: 'flex-end',
    },
  },
  button: {
    display: 'flex',
    margin: 0,
    minWidth: 'auto',
    width: 32,
    height: 32,
    padding: 0,
    background: 'none',
    cursor: 'pointer',
    border: `1px solid ${theme.color.greys[20]}`,
    borderRadius: '50%',
    '& svg path': {
      fill: theme.color.greys[75],
    },

    '&:focus-visible': {
      ...focusStyle(theme, 2),
    },
  }
}), { name: 'DialogCloseButton', index: StylesIndexInjections.UI_ATOMS });

